document.addEventListener("alpine:init", () => {
  Alpine.data("ProductCard", (id) => ({
    id,
    mainProduct: {}, // { id, title, options, variants }
    variantsMetafield: {}, // { id, metadata }
    optionsName: [], // ['Color', 'Size']
    options: {}, // { Color: ['Red', 'Blue'], Size: ['S', 'M'] }
    variants: [], // [{ id, title, options: { Color: 'Red', Size: 'M' }, ... }]
    selectedOptions: {}, // { Color: 'Red', Size: 'M' }
    selectedVariant: null,
    finalVariantIdsMap: {},
    inputVariantId: null, // The variant ID to be used in the input field for the form submission
    sellingPlanGroups: [], // Store Skio-specific selling plan groups
    subscriptionDataObj: {}, // { id, metadata }
    typePurchase: 'subscribe', // Default purchase type
    selectedSellingPlan: {}, // Selected selling plan object { }
    selectedSellingPlanId: null, // Selected selling plan
    priceFormatted: "", // Formatted price string
    priceFormattedSkio: "", // Formatted price string for SKIO
    inputSellingPlanId: null, // The variant ID to be used in the input field for the form submission
    swiperInitialized: false,

    /**
     * Initialize the component with default data
     */
    init() {
      this.typePurchase = this.$el.dataset.defaultPurchaseType;

      this.inputVariantId = this.$el.querySelector(".product-variant-id"); // Get the variant ID input field
      this.productForm = this.$el.querySelector(".js-product-form");
      this.inputSellingPlanId = this.productForm.querySelector(
        ".product-selling-plan-id"
      ); // Get the variant ID input field
      console.log("inputVariantId: ", this.inputVariantId.value);
      console.log(
        "this.inputSellingPlanId: ",
        this.inputSellingPlanId.value || "null"
      );
      console.log("this.productForm: ", this.productForm);
      this.parseProductJson(); // Parse the product JSON from the DOM
      this.filterSellingPlans(); // Filter for Skio selling plans only
      this.mapOptions(); // Extract all unique option values
      this.mapVariants(); // Map all variants with named option objects
      this.getRechargeData(); // Get SKIO data
      this.selectDefaultOptions(); // Select the default variant and options
      this.setSelectedVariantStore(this.selectedVariant); // Push the selected variant to Alpine store
      this.setSellingPlanForVariant(this.selectedVariant);
      this.$watch("$store.ProductStore.variant", (value) => {
        this.selectedVariant = value;
        this.priceFormatted = this.getPriceCorrectFormat(value);
        this.setSellingPlanForVariant(this.selectedVariant);
      });
      this.initSwiper();
      this.inputSellingPlanId.value =
        this.typePurchase === "subscribe" ? this.selectedSellingPlanId : ""; // Set the hidden input field for form submission
    },
    /**
     * Parse the product JSON from a DOM reference
     */
    parseProductJson() {
      const productData = JSON.parse(this.$refs.productDataJson.textContent);
      const productVariantsMetafieldJson = JSON.parse(
        this.$refs.productVariantsMetafieldJson.textContent
      );
      this.mainProduct = productData;
      this.variantsMetafield = productVariantsMetafieldJson;
      console.log("this.mainProduct", this.mainProduct);
      console.log("this.variantsMetafield", this.variantsMetafield);
    },

    displayButtonPrice() {
      // debugger;
      return this.typePurchase === "subscribe"
        ? this.getDiscountedPrice()
        : this.getPriceCorrectFormat(this.selectedVariant);
    },

    splitFree(text) {
      // разбиваем строку, сохраняя слово "free"
      return text.split(/(FREE)/gi);
    },

    highlightFree(text) {
      return text.replace(
        /(free)/gi,
        '<span class="is-free">$1</span>'
      );
    },

    /**
     * Get price from variant
     */
    getPriceCorrectFormat(variant) {
      if (!variant || typeof variant.price !== "number") return "";
      return `$${(variant.price / 100).toFixed(2)}`;
    },

    /**
     * Get and normalize Recharge data into simplified array
     * Updated to handle both percentage and fixed price adjustments
     */
    getRechargeData() {
      const groups = (this.mainProduct.selling_plan_groups || [])
        .filter(g => g.app_id === "294517");
    
      const allPlans = groups.flatMap(g => Array.isArray(g.selling_plans) ? g.selling_plans : []);
    
      const normalized = [];
      const seen = new Set();
    
      for (const plan of allPlans) {
        if (!plan || seen.has(plan.id)) continue;
        seen.add(plan.id);
    
        const adjustment = plan.price_adjustments?.[0] || {};
        normalized.push({
          id: plan.id,
          name: plan.name,
          discount: adjustment.value || 0,
          discount_type: adjustment.value_type || "",
          fixed_price: adjustment.value_type === "price" ? adjustment.value : null,
        });
      }
    
      this.subscriptionDataObj = { selling_plans: normalized };
      console.log("Normalized subscriptionDataObj:", this.subscriptionDataObj);
    },

    /**
     * Change type purchase
     */
    changeTypePurchase(type) {
      this.typePurchase = type;
      this.inputSellingPlanId.value =
        type === "subscribe" ? this.selectedSellingPlanId : "";
      Alpine.store("ProductStore").changeTypePurchase(type);
      console.log("this.typePurchase", this.typePurchase);
    },
    /**
     * Filter selling plan groups to only include Recharge plans
     */
    filterSellingPlans() {
      this.sellingPlanGroups =
        this.mainProduct.selling_plan_groups?.filter(
          (group) => group.app_id === "294517"
        ) || [];

      // Get all Recharge selling plan IDs for easy lookup
      this.sellingPlanIds = new Set();
      this.sellingPlanGroups.forEach((group) => {
        group.selling_plans?.forEach((plan) => {
          this.sellingPlanIds.add(plan.id);
        });
      });

      console.log("RECHARGE selling plan groups:", this.sellingPlanGroups);
      console.log(
        "RECHARGE selling plan IDs:",
        Array.from(this.sellingPlanIds)
      );
    },

    /**
     * Check if a selling plan allocation is from Skio
     * @param {Object} allocation - The selling plan allocation
     * @returns {Boolean}
     */
    isRechargeSellingPlan(allocation) {
      return this.sellingPlanIds?.has(allocation.selling_plan_id) || false;
    },

    /**
     * Get Skio selling plan by ID
     * @param {Number} planId - The selling plan ID
     * @returns {Object|null} - The selling plan object or null
     */
    getSkioSellingPlan(planId) {
      for (const group of this.sellingPlanGroups) {
        const plan = group.selling_plans?.find((sp) => sp.id === planId);
        if (plan) return plan;
      }
      return null;
    },


    initSwiper () {
      // Initialize SwiperJS for product images
      // this.swiper = new Swiper('#swiper-cart-flawors', {
      //   loop: false,
      //   slidesPerView: 3.6,
      //   spaceBetween: 10, 
      //   navigation: {
      //     nextEl: '#swiper-cart-flawors .swiper-button-next',
      //     prevEl: '#swiper-cart-flawors .swiper-button-prev',
      //   },
      //   breakpoints: {
      //     768: { 
      //       slidesPerView: 5,
      //     }
      //   },
      // });

      setTimeout(() => {
  this.swiperInitialized = true;
}, "300");
      
    },

    /**
     * Initialize the component with a new product
     * @param {Object} product - The new product object
     */
    initNewProduct(product) {
      this.mainProduct = product;
      this.init();
    },

    /**
     * Map all available product options and their unique values
     */
    mapOptions() {
      this.options = {};
      this.optionsName = [];
      this.mainProduct.options.forEach((option, index) => {
        const key = `option${index + 1}`;
        this.optionsName.push(option);
        this.options[key] = this.mainProduct.variants
          .map((v) => v.options[index])
          .filter((value, i, arr) => arr.indexOf(value) === i);
      });
    },

    /**
     * Create a normalized list of variants with key-value pair options
     * Only include Skio selling plan allocations
     */
    mapVariants() {
      this.variants = this.mainProduct.variants.map((variant) => {
        const optionsObj = {};

        this.mainProduct.options.forEach((opt, i) => {
          const key = `option${i + 1}`;
          optionsObj[key] = variant.options[i];
        });

        // Filter selling plan allocations for Skio only
        const rechargeAllocations =
          variant.selling_plan_allocations?.filter((allocation) =>
            this.isRechargeSellingPlan(allocation)
          ) || [];

        const matchedMeta = this.variantsMetafield?.find(
          (m) => m.id === variant.id
        );

        return {
          ...variant,
          optionsMapped: optionsObj,
          selling_plan_allocations: rechargeAllocations, // Only Skio allocations
          metafields: matchedMeta?.metafields || {},
        };
      });

      console.log("this.variants", this.variants);
    },

    /**
     * Set the default selected options.
     * If the URL contains a ?variant=ID, use that variant's options.
     * Otherwise, fallback to the first available variant.
     */
    selectDefaultOptions() {
      // debugger;
      if (this.variants.length === 0) return;

      const urlParams = new URLSearchParams(window.location.search);
      const variantIdFromUrl = urlParams.get("variant");

      if (variantIdFromUrl && /^\d+$/.test(variantIdFromUrl)) {
        const matchedVariant = this.variants.find(
          (v) => v.id.toString() === variantIdFromUrl
        );

        if (matchedVariant) {
          this.selectedOptions = { ...matchedVariant.optionsMapped };
          this.selectedVariant = matchedVariant;
          const lastKey = `option${this.optionsName.length}`;

          this.updateFinalVariantMap(lastKey);
          return;
        }
      }

      // fallback if variant param not found or invalid
      this.selectedOptions = { ...this.variants[0].optionsMapped };
      this.selectedVariant = this.variants[0];
      const lastKey = `option${this.optionsName.length}`;
      this.updateFinalVariantMap(lastKey);
      // debugger;
    },

    /**
     * Push the currently selected variant to the Alpine store
     * @param {Object} variant - The selected product variant object
     */
    setSelectedVariantStore(variant) {
      if (!variant || typeof variant !== "object") return;

      Alpine.store("ProductStore").set(variant);
      // Set the variant ID in the input field for form submission
      this.inputVariantId.value = variant.id;

      // Set the selected selling plan based on the variant (Skio plans only)
      const rechargeAllocations = variant.selling_plan_allocations?.filter(
        (allocation) => this.isRechargeSellingPlan(allocation)
      );

      const planId = rechargeAllocations?.[0]?.selling_plan_id;

      if (planId) {
        Alpine.store("ProductStore").setSellingPlanForVariant(planId);
      }
    },

    /**
     * Set the appropriate selling plan based on the given variant's allocations.
     * Fallbacks to the first available selling plan if none is matched.
     * @param {Object} variant - Shopify product variant object
     */
    setSellingPlanForVariant(variant) {
      // debugger;
      if (
        this.subscriptionDataObj &&
        Array.isArray(this.subscriptionDataObj.selling_plans) &&
        this.subscriptionDataObj.selling_plans.length > 0
      ) {
        const allocationId =
          variant?.selling_plan_allocations?.[0]?.selling_plan_id;
        const matchedPlan = this.subscriptionDataObj.selling_plans.find(
          (p) => p.id === allocationId
        );

        if (matchedPlan) {
          this.selectedSellingPlan = matchedPlan;
          this.selectedSellingPlanId = matchedPlan.id;
          this.inputSellingPlanId.value = this.selectedSellingPlanId; // Update the hidden input field for form submission
        } else {
          this.selectedSellingPlan = this.subscriptionDataObj.selling_plans[0];
          this.selectedSellingPlanId = this.selectedSellingPlan.id;
          this.inputSellingPlanId.value = this.selectedSellingPlanId; // Update the hidden input field for form submission
        }

        console.log("Selling plan updated:", this.selectedSellingPlan);
        // debugger;
      }
    },
    /**
     * Get discount difference as formatted amount
     * Updated to handle fixed price selling plans
     */
    getPriceDifference() {
      if (!this.selectedVariant || !this.selectedSellingPlan) return "";

      const { discount, discount_type, fixed_price } = this.selectedSellingPlan;

      // Use compare_at_price if available, otherwise fall back to price
      const basePrice =
        this.selectedVariant.compare_at_price &&
        this.selectedVariant.compare_at_price > 0
          ? this.selectedVariant.compare_at_price
          : this.selectedVariant.price;

      let finalPrice;

      // Handle fixed price selling plans - use discount field which contains the fixed price
      if (discount_type === "price") {
        finalPrice = discount;
      }
      // Handle percentage-based plans (for backward compatibility)
      else if (discount_type === "percentage" && discount > 0) {
        finalPrice = Math.round(
          this.selectedVariant.price -
            (this.selectedVariant.price * discount) / 100
        );
      }
      // Default to current variant price
      else {
        finalPrice = this.selectedVariant.price;
      }

      // Calculate price difference: base price - final price
      const priceDifference = basePrice - finalPrice;

      // Only return a positive difference
      return priceDifference > 0
        ? `$${(priceDifference / 100).toFixed(2)}` 
        : "";
    },

    /**
     * Get discount percentage for Subscribe and Save messaging
     * Calculates percentage savings from subscription price vs compare_at_price (or regular price)
     */
    getDiscountPercentage() {
      if (!this.selectedVariant || !this.selectedSellingPlan) return 0;

      const { discount, discount_type, fixed_price } = this.selectedSellingPlan;

      // Use compare_at_price if available, otherwise fall back to price
      const basePrice =
        this.selectedVariant.compare_at_price &&
        this.selectedVariant.compare_at_price > 0
          ? this.selectedVariant.compare_at_price
          : this.selectedVariant.price;
      // console.log("Base Price for discount % calculation:", basePrice);
          // const basePrice = this.selectedVariant.price;

      let subscriptionPrice;

      // Calculate subscription price based on selling plan type
      if (discount_type === "price" && fixed_price !== null) {
        subscriptionPrice = fixed_price;
      } else if (discount_type === "percentage") {
        const discountValue = (this.selectedVariant.price * discount) / 100;
        subscriptionPrice = this.selectedVariant.price - discountValue;
      } else {
        subscriptionPrice = this.selectedVariant.price;
      }

      // Calculate percentage savings and round to nearest integer
      if (basePrice > subscriptionPrice) {
        const savingsPercentage =
          ((basePrice - subscriptionPrice) / basePrice) * 100;
        return Math.round(savingsPercentage);
      }

      return 0;
    },
    /**
     * Get formatted discounted price based on selected plan
     * Updated to handle fixed price selling plans and ensure $ prefix
     */
    getDiscountedPrice() {
      // debugger;
      if (!this.selectedVariant || !this.selectedSellingPlan) return "";

      const { discount, discount_type, fixed_price } = this.selectedSellingPlan;

      // If it's a fixed price selling plan, use the fixed price directly
      if (discount_type === "price" && fixed_price !== null) {
        return `$${(fixed_price / 100).toFixed(2)}`;
      }

      // Fall back to percentage calculation for backward compatibility
      if (discount_type === "percentage") {
        const discountValue = (this.selectedVariant.price * discount) / 100;
        const discounted = this.selectedVariant.price - discountValue;
        return `$${(discounted / 100).toFixed(2)}`;
      }

      // Default to original variant price if no valid discount type
      return this.getPriceCorrectFormat(this.selectedVariant);
    },

/**
 * Get dollar amount saved with subscription (rounded to nearest dollar)
 */
getDollarSavings() {
  if (!this.selectedVariant || !this.selectedSellingPlan) return 0;

  const { discount, discount_type, fixed_price } = this.selectedSellingPlan;

  // Use compare_at_price if available, otherwise fall back to price
  const basePrice =
    this.selectedVariant.compare_at_price &&
    this.selectedVariant.compare_at_price > 0
      ? this.selectedVariant.compare_at_price
      : this.selectedVariant.price;

  let subscriptionPrice;

  // Calculate subscription price based on selling plan type
  if (discount_type === "price" && fixed_price !== null) {
    subscriptionPrice = fixed_price;
  } else if (discount_type === "percentage") {
    const discountValue = (this.selectedVariant.price * discount) / 100;
    subscriptionPrice = this.selectedVariant.price - discountValue;
  } else {
    subscriptionPrice = this.selectedVariant.price;
  }

  // Calculate dollar savings and round to nearest dollar
  if (basePrice > subscriptionPrice) {
    const dollarSavings = (basePrice - subscriptionPrice) / 100;
    return Math.round(dollarSavings);
  }

  return 0;
},
    /**
     * Called when user selects a selling plan from dropdown
     */
    onChangeSellingPlan(event) {
      const selectedId = parseInt(event.target.value);
      this.selectedSellingPlanId = selectedId;
      this.inputSellingPlanId.value = selectedId; // Update the hidden input field for form submission
      this.selectedSellingPlan =
        this.subscriptionDataObj.selling_plans.find(
          (p) => p.id === selectedId
        ) || {};
      console.log("Selected selling plan:", this.selectedSellingPlan);
    },
    /**
     * Update the selected option for a given option name
     * @param {String} name - Option name (e.g. "Option1")
     * @param {String} value - Selected value (e.g. "Red")
     */
    selectOption(name, value) {
      this.selectedOptions[name] = value;
      this.selectVariant();
      const lastKey = `option${this.optionsName.length}`;
      this.updateFinalVariantMap(lastKey);
    },

    /**
     * Find and set the selected variant based on current selectedOptions
     */
    selectVariant() {
      this.selectedVariant =
        this.variants.find((v) => {
          return Object.entries(this.selectedOptions).every(([key, value]) => {
            return v.optionsMapped[key] === value;
          });
        }) || null;

      // Update the URL with the selected variant ID
      if (this.selectedVariant) {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", this.selectedVariant.id);
        window.history.replaceState({}, "", url);
        // Push to Alpine store
        this.setSelectedVariantStore(this.selectedVariant);
        console.log("Selected variant:", this.selectedVariant);
      }
    },

    /**
     * Get mapping of option values to variant IDs for the final option level.
     * This can be used to render buttons with attached variant IDs.
     * Uses only Skio selling plan data.
     * @param {String} optionKey - like "option3"
     * @returns {Object} - { "Black": 1234567890, "White": 1234567891 }
     */
    updateFinalVariantMap(optionKey) {
      // debugger;
      const filtered = this.variants.filter((v) => {
        return Object.entries(this.selectedOptions).every(([key, value]) => {
          return key === optionKey || v.optionsMapped[key] === value;
        });
      });

      if (filtered.length === 0) {
        this.finalVariantIdsMap[optionKey] = {};
        return;
      }

      const map = {};

      filtered.forEach((v) => {
        // Only use Skio selling plan allocations
        const rechargeAllocations = v.selling_plan_allocations?.filter(
          (allocation) => this.isRechargeSellingPlan(allocation)
        );

        if (!rechargeAllocations || rechargeAllocations.length === 0) return; // Skip if no Skio plans

        const allocation = rechargeAllocations[0]; // Use first Skio allocation
        const value = v.optionsMapped[optionKey];
        const priceRaw = allocation.price;
        const compareAtRaw = allocation.compare_at_price;
        const sellingPlanId = allocation.selling_plan_id;

        // Default to 30 days in a month
        let dayCount = 30;

        // Find matching Skio selling plan by ID
        const sellingPlan = this.getSkioSellingPlan(sellingPlanId);
        const sellingPlanName = sellingPlan?.name || "";

        // Adjust days based on plan name
        if (sellingPlanName.includes("1 Month")) {
          dayCount *= 1;
        } else if (sellingPlanName.includes("2 Month")) {
          dayCount *= 2;
        } else if (sellingPlanName.includes("3 Month")) {
          dayCount *= 3;
        }

        // Get the bottle count from the variant title/name - look for pack size patterns
        let bottleCount = 8; // default
        const variantTitle = (v.title || '').toLowerCase();

        // Match patterns like "4 pack", "4pack", "4-pack", etc.
        if (variantTitle.match(/\b24[\s-]?pack\b/i) || variantTitle.includes('24 pack')) {
          bottleCount = 24;
        } else if (variantTitle.match(/\b16[\s-]?pack\b/i) || variantTitle.includes('16 pack')) {
          bottleCount = 16;
        } else if (variantTitle.match(/\b8[\s-]?pack\b/i) || variantTitle.includes('8 pack')) {
          bottleCount = 8;
        } else if (variantTitle.match(/\b4[\s-]?pack\b/i) || variantTitle.includes('4 pack')) {
          bottleCount = 4;
        }

        console.log('Variant:', variantTitle, 'Bottle count:', bottleCount); // Debug log

        const servingSubscribe =
          typeof priceRaw === "number"
            ? (priceRaw / bottleCount / 100).toFixed(2)
            : null;

        const servingOneTime =
          typeof compareAtRaw === "number"
            ? (compareAtRaw / dayCount / 100).toFixed(2)
            : null;

        map[value] = {
          id: v.id,
          available: v.available,
          ...(v.metafields ? { metafields: v.metafields } : {}),
          servingSubscribe,
          servingOneTime,
        };
      });

      this.finalVariantIdsMap = {
        ...this.finalVariantIdsMap,
        [optionKey]: map,
      };
      // debugger;
    },

    hasBadgeValue(key, value, field) {
      const val = this.finalVariantIdsMap?.[key]?.[value]?.metafields?.[field];
      // Check if the value is not null, undefined, or an empty string
      if (val !== undefined && val !== null && val !== "") {
        return true;
      }
      return false;
    },
  }));
});

window.onload = function () {
  const blockreviews = document.querySelector('[data-oke-rendered]');
  const reviewsTitle = document.querySelector('.rf__header.rf__header-section.rf__header-center');

  if (blockreviews && reviewsTitle) { 
    const copy = blockreviews.cloneNode(true);
    copy.classList.add('reviews-clone');

    copy.addEventListener('click', () => {
      const simple_block = document.querySelector('.oke-is-large');

      if (!simple_block) {
        console.warn('Reviews block (.oke-is-large) not found yet');
        return;
      }

      console.log('Scroll to reviews section');
      const top = simple_block.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    });

    reviewsTitle.insertAdjacentElement('afterend', copy);
  }
};
